import ReactDOM from "react-dom";
import App from "./App";

// const App = require("./App").default;

ReactDOM.render(<App />, document.getElementById("root"));
